<template>
  <div class="flex size-full flex-col px-3 text-gray-700 md:p-0">
    <p class="text-left text-xl md:text-2xl">
      <span class="">¿Cuál de</span>
      <span class="font-serif"> estás opciones describe </span>
      <span class="">mejor tu tienda? </span>
    </p>
    <form
      class="flex w-full flex-col"
      @submit.prevent="onSubmit"
    >
      <div class="mt-5 grid w-full grid-cols-2 gap-3 md:mt-8">
        <button
          v-for="option in shopCategoryOptions"
          :key="option.id"
          type="button"
          class="flex items-center rounded-md border border-gray-300 p-3"
          :class="{ 'border-gray-700': option.id === selectedShopCategory.id }"
          @click="(selectedShopCategory = option)"
        >
          <p
            class="w-full rounded-md text-left text-sm font-light text-gray-700 md:text-base"
            :class="{ 'font-normal': option.id === selectedShopCategory.id }"
          >
            {{ option.name }}
          </p>
        </button>
        <custom-input
          v-if="selectedShopCategory.id === 9"
          v-model="otherShopCategory"
          class="col-span-2 mt-3"
          name="shops[other_category]"
          label="Otro tipo de tienda"
          placeholder="Otro tipo de tienda"
          :rules="{ required: true }"
        />
        <Field
          v-model="shopCategory"
          class="w-full border p-2"
          name="shopCategory"
          hidden
          type="string"
          label="Tipo de tienda"
          :rules="{ required: true }"
        />
      </div>
      <div class="mt-5 flex w-full flex-col items-center md:mt-8">
        <button
          class="w-full rounded-md bg-gray-700 p-2 text-sm text-white md:text-base"
          :class="{ 'opacity-80': anyErrors, 'hover:bg-gray-800': !anyErrors }"
          :disabled="anyErrors"
        >
          Continuar
        </button>
        <a
          class="mt-1 cursor-pointer text-xs hover:underline md:text-sm"
          @click="previousStep"
        >
          Volver
        </a>
        <ErrorMessage
          name="shopCategory"
          class="text-xs text-red-500 md:text-sm"
        />
      </div>
    </form>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed, watch, onMounted } from 'vue';
import { Field, ErrorMessage, useForm } from 'vee-validate';
import useSignUpStore from 'stores/sign-up-store';
import customInput from './shared/custom-input.vue';

const signUpStore = useSignUpStore();

interface ShopCategoryOption {
  id: number;
  name: string;
}

const selectedShopCategory = ref({} as ShopCategoryOption);
const shopCategory = computed(() => selectedShopCategory.value.name as string);
const otherShopCategory = ref('');
const shopCategoryOptions = ref([
  { id: 0, name: 'Emporio' },
  { id: 1, name: 'Almacén o minimarket' },
  { id: 2, name: 'Farmacia' },
  { id: 3, name: 'Mascotas' },
  { id: 4, name: 'Supermercado' },
  { id: 5, name: 'Cafetería' },
  { id: 6, name: 'A granel' },
  { id: 7, name: 'Verdulería' },
  { id: 8, name: 'Deportiva' },
  { id: 9, name: 'Otro' },
] as ShopCategoryOption[]);

function previousStep() {
  signUpStore.currentStep = 'shop-name';
}

watch(shopCategory, (newCategory) => {
  signUpStore.shopForm.categoryName = newCategory;
  if (newCategory !== 'Otro') {
    otherShopCategory.value = '';
  }
});

watch(otherShopCategory, (newOtherShopCategory) => {
  signUpStore.shopForm.categoryName = newOtherShopCategory;
});

onMounted(() => {
  const foundCategory = shopCategoryOptions.value.find((option) => option.name === signUpStore.shopForm.categoryName);
  if (foundCategory) {
    selectedShopCategory.value = foundCategory;
  } else if (signUpStore.shopForm.categoryName) {
    selectedShopCategory.value = { id: 9, name: 'Otro' };
    otherShopCategory.value = signUpStore.shopForm.categoryName;
  }
});

const { handleSubmit, errors } = useForm();
const anyErrors = computed(() => Object.keys(errors.value).length > 0);
const onSubmit = handleSubmit(() => {
  signUpStore.currentStep = 'shop-since';
});
</script>
